// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.DiHtml53DEffects = function DiHtml53DEffects(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "version": "1.1",
      "viewBox": "0 0 32 32"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M16.957 6.062l-5.808 1.88 12.58 4.070v8.027l-8.383 2.711-7.074-2.287v-7.863l6.836 2.213 5.808-1.879-12.598-4.077-3.622 1.172v13.036l10.649 3.445 11.958-3.869v-13.23z"
      }
    }]
  })(props);
};